import React from 'react';
import MenuHome from '../../../components/MenuHome';
import MenuComputerScience from '../../../components/MenuComputerScience';
import MenuProgramming from '../../../components/MenuProgramming';
import '../../../styles/main.scss';

const R= () => {
  return <div>
        <div className="title">R</div>
        <div class="caption"></div>
        <MenuHome />
        <MenuComputerScience />
        <MenuProgramming />
  </div>;
};

export default R;